import React, { useEffect, useState } from "react";
import './SideBarStyles.scss';
// import  "../pages/FolderManagement/FolderManagement.scss";
import QuestionnaireResult from "./QuistionnaireResult";
import CloseIcon from "./CloseIcon";


const SideBar = ({isExpired,designation="",name, showSideBar, setShowSideBar,middleware,questionnaireId,editQuestionnaire=()=>{},platform,score_Data=null,imageUrl}) => {
  const [grayOverlay, setGrayOverlay] = useState(false);
console.log({showSideBar,middleware,questionnaireId})
  useEffect(() => {
    let timeoutId;

    if (showSideBar) {
      timeoutId = setTimeout(() => setGrayOverlay(true), 250);
    } else {
      setGrayOverlay(false);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [showSideBar]);

  return (
    <div className="Sidebar-container"
     style={{ 
      width: showSideBar ? '100vw' : '0',
    }}
    >
      <div className="content_section">
        <QuestionnaireResult isExpired={isExpired} showSideBar={showSideBar} designation={designation} name={name} imageUrl={imageUrl} platform={platform} editQuestionnaire={editQuestionnaire} height='100vh' middleware={middleware} questionnaireId={questionnaireId} score_Data={score_Data}/> 
      </div>
     
     {grayOverlay && <div className="gray_container" onClick={() => setShowSideBar(false)}>
         <div onClick={() => setShowSideBar(false)} className="close_icon">
          <CloseIcon />
        </div>
      </div>}

    </div>
  );
};

export default SideBar;
